import { render } from 'react-dom';
import Login from '../login/Login';
import {ServerPaths} from '../../../src/settings.js';
import './Topbar.css';



function Topbar(props){

    //TODO 
    //controlar exibicao sol. ordem ou os dois

    const logOut = () => {
        window.sessionStorage.removeItem("userId");
        window.sessionStorage.removeItem("token");
        return render(<Login/>, document.getElementById('root'));
    }
    
    return (
        <div className='container-fluid barcont'>
            <div className='container' style={{padding:'0'}}>
            <div className='d-flex justify-content-between adj1'>
                <div className='d-flex align-self-center '>
                    <img src="logo1.png" alt="" />
                </div>
                <div className='d-flex align-self-center'>
                    {props.location}
                </div>
                <div className='d-flex align-self-center'>
                    <div className="btn-group">
                        <img className='rounded-circle ' src={ServerPaths.userPhoto + props.uPhoto} alt="" width="36px" height="36px"  data-bs-toggle="dropdown" />  
                        
                        <ul className="dropdown-menu dropdown-menu-end dmenu">
                            <li>
                                <div className="dropdown-item ditem" onClick={logOut}>Sair</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default Topbar